export default class Recurly {
  constructor() {
    this.paymentForm = document.querySelector('.needs-payment-info');
    if (this.paymentForm) {
      this.validator = window.solodev.formValidators[this.paymentForm.id];
      this.originalSubmit = this.validator.originalSubmit;
      this.initRecurlyForm(this.paymentForm);
    }

    const repeatPaymentBtn = document.querySelector('.js-repeat-payment');
    if (repeatPaymentBtn) {
      this.repeatPaymentBtn = repeatPaymentBtn;
      this.repeatPayment();
    }
  }

  initRecurlyForm(form) {
    const self = this;
    const { elements, recurly } = this.recurlySetup(form);
    if (window.isBaseTemplate || false) {
      this.validator.addFieldValidation(form.id+'[recurly-token]', (value, resolve, reject) => {
        recurly.token(elements, form, function (err, token) {
          self.clearErrors();
          if (err) {
            self.errorHandler(err);
            reject();
          } else {
            resolve();
          }
        });
      });
    } else {
      const modal = window.parent.document.querySelector('.modal.show');
      const modalSubmitBtn = modal ? modal.querySelector('.modal-confirm') : null
      if (modalSubmitBtn) {
        modalSubmitBtn.addEventListener('click', () => {
          self.validator.originalSubmit = self.recurlyFormSubmitHandler.bind(this, form, null, elements, recurly, self.originalSubmit);
        });
      }
    }
  }

  recurlySetup(form) {
      const recurlyElements = form.querySelector('#recurly-elements');
      const requiredFields = ['cvv'];
      recurly.configure({
        publicKey: recurlyElements.getAttribute('data-id'),
        required: requiredFields
      });
      const elements = recurly.Elements();
      const cardElement = elements.CardElement({
        style: {
          textTransform: 'capitalize',
          fontFamily: '"Inter", "Roboto", "Arial", sans-serif',
        }
      });
      cardElement.attach('#recurly-elements');

      return {
        elements,
        recurly,
      }
  }

  recurlyFormSubmitHandler = function(form, event, recurlyElements, API, originalSubmit) {
    const self = this;
    event && event.preventDefault();
    self.clearErrors();
    API.token(recurlyElements, form, function (err, token) {
      const hasJsValidatorErrors = document.querySelectorAll('.form-control.error.validation-error');
      if (err || hasJsValidatorErrors.length !== 0) {
        self.validator.valid = false;
        self.errorHandler(err);
      } else {
        // recurly-form.js has filled in the 'token' field, so now we can submit the
        // form to your server
        originalSubmit.call(form);
      }
    });
  }

  clearErrors() {
    document.querySelectorAll('label.error').forEach((label) => {
      label.textContent = '';
      const input = label.parentNode.querySelector('input[type="text"].error');
      if (input && input.value) {
        input.classList.remove('error');
      }
    });
  }

  errorHandler(err) {
    const formErrors = [];
    err.fields.forEach((field, i) => {
      const element = document.querySelector('[data-recurly=' + field + ']');
      if (element) {
        this.validator.setError(element.name, 'This field is required');
      } else {
        formErrors.push(field);
      }
    });

    // For Credit Car Input validation
    const recurlyErrorContainer = document.querySelector('#recurly-errors');
    const recurlyError = document.querySelector('#recurly-validation-error');
    if (recurlyErrorContainer && formErrors && formErrors.length) {
      if (recurlyError) {
        recurlyError.classList.add('d-none');
      }
      const message = 'The following fields appear to be invalid: ' + formErrors.join(', ');
      recurlyErrorContainer.innerHTML = '<li>' + message + '</li>';

      const recurlyElement = document.querySelector('.recurly-element');
      recurlyElement.classList.add('recurly-element-invalid');
      recurlyElement.classList.add('recurly-element-card-invalid');
      this.validator.submitBtn.removeAttribute('disabled');

      this.onClassChange(recurlyElement, (node) => {
        if (node.classList.contains('recurly-element-valid')) {
          recurlyErrorContainer.innerHTML = '<li></li>';
        }
      });
    }
  }

  onClassChange(element, callback) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          callback(mutation.target);
        }
      });
    });
    observer.observe(element, { attributes: true });
    return observer.disconnect;
  }

  repeatPayment() {
    this.repeatPaymentBtn.addEventListener('click', () => {
      const text = document.querySelector('span', this.repeatPaymentBtn);
      const group = this.repeatPaymentBtn.parentElement;
      text.innerHTML = 'Payment in progress...';
      $.ajax({
        url: this.repeatPaymentBtn.getAttribute('data-url'),
        type: 'post',
        dataType: 'json',
        success: function(res) {
          text.innerHTML = 'Repeat payment';
          if (res.result) {
            top.document.location = group.dataset.name;
            top.closeAction();
          } else {
            const error = document.querySelector('.js-error');
            error.innerHTML = 'Payment failed. Error returned by payment service: ' + res.error;
            error.classList.remove('d-none');
          }
        }
      });
    });
  }
}
